export const EventCode = {
	Container: {
		Completed: "Completed",
		Dehired: "Dehired",
		DeliveredTerminal: "DeliveredTerminal",
		EIDOReceived: "EIDOReceived"
	}
} as const;
